// === DOM Utilities ===

export function escapeHtml(text) {
  if (!text) return '';
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#039;')
    .replace(/"/g, '&quot;');
}

// Lazy-initialized DOM element references.
// Modules load before DOM is ready, so we resolve on first call.
let _els = null;

export function getElements() {
  if (_els) return _els;
  _els = {
    appHeader: document.querySelector('.app-header'),
    monthPills: document.getElementById('monthPills'),
    urgentGrid: document.getElementById('urgentGrid'),
    normalGrid: document.getElementById('normalGrid'),
    urgentSection: document.getElementById('urgentSection'),
    emptyMsg: document.getElementById('emptyMsg'),
    btnGrid: document.getElementById('btnViewGrid'),
    btnList: document.getElementById('btnViewList'),
    onboarding: document.getElementById('onboarding'),
    onboardStep1: document.getElementById('onboardStep1'),
    onboardStep2: document.getElementById('onboardStep2'),
    btnGetStarted: document.getElementById('btnGetStarted'),
    splashTitle: document.getElementById('splashTitle'),
    splashSubtitle: document.getElementById('splashSubtitle'),
    splashFeatures: document.getElementById('splashFeatures'),
    splashResetHint: document.getElementById('splashResetHint'),
    homePanel: document.getElementById('homePanel'),
    homeHerdType: document.getElementById('homeHerdType'),
    homeSeasons: document.getElementById('homeSeasons'),
    homeProgressLabel: document.getElementById('homeProgressLabel'),
    homeProgressCount: document.getElementById('homeProgressCount'),
    homeProgressFill: document.getElementById('homeProgressFill'),
    homeInstall: document.getElementById('homeInstall'),
    btnHomeInstall: document.getElementById('btnHomeInstall'),
    btnHomeEditSetup: document.getElementById('btnHomeEditSetup'),
    btnHomeDefaults: document.getElementById('btnHomeDefaults'),
    homeTextlinks: document.getElementById('homeTextlinks'),
    btnHome: document.getElementById('btnHome'),
    startPlanning: document.getElementById('btnStartPlanning'),
    onboardError: document.getElementById('onboardError'),
    herdButtons: Array.from(document.querySelectorAll('[data-herd]')),
    btnEditProfile: document.getElementById('btnEditProfile'),
    seasonDatesSection: document.getElementById('seasonDatesSection'),
    seasonSelects: Array.from(document.querySelectorAll('.season-select')),
    dryingOffRow: document.getElementById('dryingOffRow'),
    selCalving: document.getElementById('selCalving'),
    selTurnout: document.getElementById('selTurnout'),
    selHousing: document.getElementById('selHousing'),
    selBreeding: document.getElementById('selBreeding'),
    selDryingOff: document.getElementById('selDryingOff')
  };
  return _els;
}
